import React from 'react';
import { Typography, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

const { Text } = Typography;

const rowStyle = {
  display: 'flex',
  borderBottom: '1px solid rgba(180,180,180,0.34)',
};

const cellStyle = {
  flex: 1,
  padding: '10px',
  borderRight: '1px solid rgba(180,180,180,0.34)',
  background: 'white',
  fontSize: 14,
  fontWeight: 400,
  display: 'flex',
  alignItems: 'center',
  background: '#FCF8F8', // match Figma value cell background
};

const { background, ...cellStyleWithoutBg } = cellStyle;

const lastCellStyle = {
  ...cellStyleWithoutBg,
  borderRight: 'none',
  justifyContent: 'flex-start',
  borderRadius: 0,
};

const KeyValuePair = ({ label, value, hasPreview = false, previewFile = () => {} }) => (
  <div style={rowStyle}>
    <div style={cellStyle}>{label}</div>
    <div style={lastCellStyle}>
      {hasPreview && Array.isArray(value) ? (
        <div style={{ width: '100%' }}>
          {value.map((item, idx) => (
            <div key={idx} style={{ display: 'flex', alignItems: 'center' }}>
              <Text style={{ fontSize: 14, fontWeight: 400 }}>
                {item.name}
              </Text>
              <Button
                type="text"
                icon={<EyeOutlined style={{ color: '#1677ff' }} />}
                style={{ marginLeft: 8, padding: 0 }}
                size="small"
                onClick={() => previewFile(item)}
              />
            </div>
          ))}
        </div>
      ) : (
        <React.Fragment>
          <Text style={{ width: '100%', fontSize: 14, fontWeight: 400 }}>
            {value || '-'}
          </Text>
          {hasPreview && value && (
            <Button
              type="text"
              icon={<EyeOutlined />}
              style={{ marginLeft: 8, padding: 0 }}
              size="small"
            />
          )}
        </React.Fragment>
      )}
    </div>
  </div>
);

export default KeyValuePair;